import { PERMITIONS } from 'components/DrawerMenu/routes_list'
import AuthProvider from 'context/AuthContext'
import { DrawerProvider } from 'context/DrawerContext'
import useAuth from 'hooks/useAuth'
import AcessEmail from 'pages/AcessEmail/AcessEmail'
import BlankPage from 'pages/BlankPage/BlankPage'
import ConsultaDocumentos from 'pages/GST/ConsultaDocumentos'
import ConsultaJobs from 'pages/GST/ConsultaJobs/JobsConsultation'
import ParameterizationGst from 'pages/GST/Parametrizacao'
import SearchByContract from 'pages/GST/PesquisaPorContrato'
import FineGraduation from 'pages/GST/Registers/FineGraduation/FineGraduation'
import SecurityItemsAndSubItems from 'pages/GST/Registers/SecurityItemsAndSubItems/SecurityItemsAndSubItems'
import WorkAccidentOccurrence from 'pages/GST/Registers/WorkAccidentOccurrence/WorkAccidentOccurrence'
import Dashboard from 'pages/GST/Reports/Dashboard'
import PendingItems from 'pages/GST/Reports/PendingItems/PendingItems'
import TalkToUsGst from 'pages/GST/TalkToUs'
import { FornecedoAccess } from 'pages/Login/components/FornecedorAccess/fornecedorAccess'
import { NGTAccess } from 'pages/Login/components/NGTAccess/NGTAccess'
import AnalystCockpit from 'pages/NGT/Cockpit/AnalystCockpit/AnalystCockpit'
import ManagerialCockpit from 'pages/NGT/Cockpit/ManagerialCockpit/ManagerialCockpit'
import Contracts from 'pages/NGT/Contracts/Contracts'
import ConventionRegistration from 'pages/NGT/ConventionRegistration'
import AnalyzeCre from 'pages/NGT/CRE/AnalyzeCreContract'
import Cre from 'pages/NGT/CRE/Cre'
import PendingAnalysisCre from 'pages/NGT/CRE/PendingAnalysisCre'
import DJURService from 'pages/NGT/DJURService/DJURService'
import { LogicalEffective as ContraparteLogicalEffective } from 'pages/NGT/Effective/Effective'
import EffectiveConsolidation from 'pages/NGT/Effectives/EffectiveConsolidation/EffectiveConsolidation'
import { DocumentationFile, RegisterDocumentation } from 'pages/NGT/Files/Files'
import Log from 'pages/NGT/Log'
import Parameterization from 'pages/NGT/Parameterization/Parameterization'
import QueryJobs from 'pages/NGT/QueryJobs/QueryJobs'
import RecordSheet from 'pages/NGT/RecordSheet'
import RecordsRegistration from 'pages/NGT/RecordsRegistration'
import {
  ReportsContracts,
  ReportsEffectives,
  ReportsSupplier
} from 'pages/NGT/Reports'
import ReportsAcess from 'pages/NGT/Reports/ReportsAcess/ReportsAcess'
import ContractView from 'pages/NGT/Reports/ReportsAcess/ResultsReportsAcess/ContractView'
import SupplierView from 'pages/NGT/Reports/ReportsAcess/ResultsReportsAcess/SupplierView'
import ReportsBlock from 'pages/NGT/Reports/ReportsBlock/ReportsBlock'
import RecordSheetBlock from 'pages/NGT/Reports/ReportsBlock/ResultsReportsBlock/RecordSheetBlock'
import SupplierBlock from 'pages/NGT/Reports/ReportsBlock/ResultsReportsBlock/SupplierBlock'
import { ReportsCRE } from 'pages/NGT/Reports/ReportsCRE/ReportsCRE'
import { ResultsReportsCRE } from 'pages/NGT/Reports/ReportsCRE/ResultsReportsCRE/ResultsReportsCRE'
import { ReportsContractCurrent } from 'pages/NGT/Reports/ReportsCurrentContracts'
import { ReportsCounterpart } from 'pages/NGT/Reports/ReportsCounterpart'
import HHTandSalaryReportsReport from 'pages/NGT/Reports/ReportsEffectives/components/HHTandSalaryReportsReport/HHTandSalaryReportsReport'
import TTlContractReport from 'pages/NGT/Reports/ReportsEffectives/components/ThirdpartyStaffBySupplier/ThirdpartyStaffBySupplier'
import { ReportsSalary } from 'pages/NGT/Reports/ReportsSalary/ReportsSalary'
import SupplierRegistration from 'pages/NGT/SupplierRegistration'
import TalkToUs from 'pages/NGT/TalkToUs'
import ValidationAccess from 'pages/NGT/ValidationAccess/ValidationAccess'
import { ViewContract } from 'pages/NGT/ViewContract/viewContract'
import NotFound from 'pages/NotFound'
import PasswordRecovery from 'pages/PasswordRecovery/PasswordRecovery'
import { ThirdParty } from 'pages/Supplier/AttachDocuments'
import WorkSafety from 'pages/Supplier/AttachDocuments/WorkSafety'
import { LogicalEffective } from 'pages/Supplier/Effective/Effective'
import MovMensal from 'pages/Supplier/MovMensal/MovMensal'
import TalkWithUs from 'pages/Supplier/TalkWithUs'
import CollaboratorContract from 'pages/Supplier/Users/CollaboratorContract'
import Users from 'pages/Supplier/Users/Users'
import ValidateUser from 'pages/ValidateUser/ValidateUser'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { useToggle as openReportsCounterpart } from 'hooks'

import { FirstPage, Syndicate } from '../pages'
import RouteWithTitle from './RouteWithTitle/RouteWithTitle'
import RecordSheetBlockFullSuplier from 'pages/NGT/Reports/ReportsBlock/ResultsReportsBlock/RecordSheetBlockFullSuplier'

export const paths = [
  // {
  //   exact: true,
  //   hideMenus: true,
  //   page: <Login />,
  //   path: "/",
  // },
  {
    exact: true,
    page: <Users />,
    path: '/fornecedor/usuarios',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO
    ],
    title: 'Usuários'
  },
  {
    exact: true,
    page: <MovMensal />,
    path: '/movimentacao',
    permition: [
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORNGT,
      //PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      //PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO,
      PERMITIONS.CSNTI
    ],
    title: 'Movimentação Mensal'
  },
  {
    exact: true,
    page: <EffectiveConsolidation />,
    path: '/ngt/consolidacao-efetivo',
    permition: [
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.CSNTI
    ],
    title: 'Consolidação Efetivo'
  },
  {
    exact: true,
    page: <BlankPage />,
    path: '/fornecedor',
    permition: [],
    title: 'Fornecedor'
  },
  {
    exact: true,
    page: <BlankPage />,
    path: '/ngt',
    permition: [],
    title: 'CSN'
  },
  {
    exact: true,
    page: <TalkWithUs />,
    path: '/fornecedor/contato',
    permition: [
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORNGT,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO,
      PERMITIONS.ADMINISTRADOR
    ],
    title: 'Fale Conosco'
  },
  {
    page: <SupplierView />,
    path: '/ngt/relatorios-acesso-fornecedor',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIO DE ACESSO POR FORNECEDOR'
  },
  {
    page: <ContractView />,
    path: '/ngt/relatorios-acesso-contrato',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIO DE ACESSO POR CONTRATO'
  },
  {
    page: <RecordSheetBlock />,
    path: '/ngt/relatorio-fornecedor-bloqueado',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Relatório de Fornecedor Bloqueado para Pagamento'
  },
  {
    page: <RecordSheetBlockFullSuplier />,
    path: '/ngt/relatorio-todos-fornecedores',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Relatório completo dos Fornecedores'
  },
  {
    page: <RecordSheetBlock />,
    path: '/ngt/relatorio-fr-bloqueada',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Relatório de Folha de Registro Bloqueadas'
  },
  {
    page: <RecordSheetBlock />,
    path: '/ngt/relatorio-fr-liberada',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Relatório de Folha de Registro Liberadas'
  },
  {
    page: <LogicalEffective />,
    path: '/fornecedor/efetivos/cadastro-efetivo',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO,
      PERMITIONS.FORNECEDOROPERADORNGT
    ],
    title: 'Cadastro Efetivo Lógico'
  },
  {
    page: <ContraparteLogicalEffective />,
    path: '/ngt/efetivos/cadastro-efetivo',
    permition: [PERMITIONS.CSNCONTRAPARTE],
    title: 'Cadastro Efetivo Lógico'
  },
  {
    page: <ThirdParty />,
    path: '/fornecedor/anexar-documentos/gestao-terceiros',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO,
      PERMITIONS.FORNECEDOROPERADORNGT
    ],
    title: 'Gestão de Terceiros'
  },
  {
    page: <WorkSafety />,
    path: '/fornecedor/anexar-documentos/gst',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.FORNECEDORADMINISTRADOR,
      PERMITIONS.FORNECEDOROPERADORGST,
      PERMITIONS.FORNECEDOROPERADORHIBRIDO,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.CSNTI
    ],
    title: 'Gestão de Segurança do Trabalho'
  },
  {
    page: <CollaboratorContract />,
    path: '/contratos-usuario',
    permition: [],
    title: 'CONTRATO'
  },
  {
    page: <ManagerialCockpit />,
    path: '/ngt/cockpit/cockpit-gerencial',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Cockpit NGT'
  },
  {
    page: <AnalystCockpit />,
    path: '/ngt/cockpit/cockpit-analista',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Cockpit NGT'
  },
  {
    page: <SupplierRegistration />,
    path: '/ngt/cadastro-fornecedor',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Cadastro Fornecedor'
  },
  {
    page: <ConventionRegistration />,
    path: '/ngt/cadastro-convencao',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Acordo e Convenção'
  },
  {
    page: <Syndicate />,
    path: '/ngt/sindicato',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Sindicato'
  },
  {
    page: <TalkToUs />,
    path: '/ngt/fale-conosco',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Fale Conosco'
  },
  {
    page: <RecordsRegistration />,
    path: '/ngt/cadastro-pendencia',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Cadastro de Itens - Pendência'
  },
  {
    page: <ValidationAccess />,
    path: '/ngt/acesso',
    permition: [
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.CSNTI
    ],
    title: 'Validação de Acesso'
  },
  {
    page: <RecordSheet />,
    path: '/ngt/folha-registro',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Folha de Registro'
  },
  {
    page: <Parameterization />,
    path: '/ngt/parametrizacao',
    permition: [PERMITIONS.ADMINISTRADOR, PERMITIONS.NGTNORMATIVO,
    PERMITIONS.CSNTI, PERMITIONS.CSNSEGURANCALOGICA],
    title: 'Parametrização'
  },
  {
    page: <SearchByContract />,
    path: '/gst/pesquisa-por-contrato',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Pesquisa por contrato'
  },
  {
    page: <ConsultaDocumentos />,
    path: '/gst/consulta-documentos',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Consulta de documentos'
  },
  {
    page: <TalkToUsGst />,
    path: '/gst/fale-conosco',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'Fale Conosco'
  },
  {
    page: <ParameterizationGst />,
    path: '/gst/parametrizacao',
    permition: [PERMITIONS.ADMINISTRADOR, PERMITIONS.GSTNORMATIVO,
    PERMITIONS.CSNTI],
    title: 'Parametrizacao'
  },
  {
    page: <ConsultaJobs />,
    path: '/gst/consulta-jobs',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.CSNTI
    ],
    title: 'Consulta Jobs'
  },
  {
    page: <QueryJobs />,
    path: '/ngt/jobs-enviados',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Jobs - Enviados'
  },
  {
    page: <DocumentationFile />,
    path: '/ngt/arquivos/documentação',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Arquivo Documentação - Trabalhista e Previdenciária'
  },
  {
    page: <RegisterDocumentation />,
    path: '/ngt/arquivos/cadastro',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Cadastro de Guarda de Documentos'
  },
  {
    page: <DJURService />,
    path: '/ngt/djur',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Atendimento DJUR'
  },
  {
    page: <Contracts />,
    path: '/ngt/contratos-pesquisar',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Contrato'
  },
  {
    page: <Cre />,
    path: '/ngt/carteira-cre',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Carteira'
  },
  {
    page: <AnalyzeCre />,
    path: '/ngt/analise-cre',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Análise CRE'
  },
  {
    page: <PendingAnalysisCre />,
    path: '/ngt/analise-pendencia-cre',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Análise Pendências CRE'
  },
  {
    page: <ViewContract />,
    path: '/ngt/visualizar-contrato',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Visualizar Contrato'
  },
  {
    page: <ReportsCRE />,
    path: '/ngt/relatorio-cre',
    permition: [
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIO CRE - Controle de Recolhimento de Encargos'
  },
  {
    page: <ResultsReportsCRE />,
    path: '/ngt/relatorio-cre-resultado',
    permition: [
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Resultado Relatório CRE'
  },
  {
    page: <ReportsAcess />,
    path: '/ngt/relatorios-acesso',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIOS DE ACESSO'
  },
  {
    page: <ReportsBlock />,
    path: '/ngt/relatorios-bloqueio',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIOS DE BLOQUEIO / LIBERAÇÃO'
  },
  {
    page: <ReportsEffectives />,
    path: '/ngt/relatorios-efetivos',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],

    title: 'RELATÓRIOS EFETIVOS'
  },
  {
    page: <ReportsContracts />,
    path: '/ngt/relatorios-contracts',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'EFETIVOS DE TERCEIROS POR CONTRATO'
  },
  {
    page: <ReportsContractCurrent />,
    path: '/ngt/relatorios-contratos-vigentes',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Relatório de contratos vigentes'
  },
  {
    page: <ReportsSupplier />,
    path: '/ngt/relatorios-fornecedor',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'EFETIVOS DE TERCEIROS POR FORNECEDOR'
  },
  {
    page: <ReportsSalary />,
    path: '/ngt/relatorios-salario',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIO DE RELATÓRIOS DE HHT E SALÁRIO'
  },
  {
    page: <ReportsCounterpart showModal2={true} />,
    path: '/ngt/relatorios-contraparte',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNCONTRAPARTE,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIO CONTRAPARTE'
  },
  {
    page: <Log />,
    path: '/ngt/log',
    permition: [PERMITIONS.CSNTI],
    title: 'LOGS'
  },
  {
    page: <SecurityItemsAndSubItems />,
    path: '/gst/cadastro/itens-subitens-segurança',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'CADASTRO DE ITEM/SUBITEM DE SEGURANÇA'
  },
  {
    page: <WorkAccidentOccurrence />,
    path: '/gst/cadastro/ocorrencia-acidente-trabalho',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'OCORRÊNCIAS'
  },
  {
    page: <HHTandSalaryReportsReport />,
    path: '/ngt/relatorios-vizualizar-efetivos-hht-salario',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'Relatório de HHT x Salário por Contrato'
  },
  {
    page: <TTlContractReport />,
    path: '/ngt/relatorios-vizualizar-efetivos-terceiros-fornecedor',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.NGTNORMATIVO,
      PERMITIONS.NGTANALISTA,
      PERMITIONS.CSNTI
    ],
    title: 'EFETIVOS DE TERCEIROS POR CONTRATO'
  },
  {
    page: <FineGraduation />,
    path: '/gst/cadastro/gradacao-multas',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'GRADAÇÃO DE MULTAS'
  },
  {
    page: <PendingItems />,
    path: '/gst/relatorios/itens-pendentes',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'RELATÓRIOS'
  },
  // {
  //   page: <General />,
  //   path: '/gst/relatorios/geral',
  //   permition: [
  //     PERMITIONS.ADMINISTRADOR,
  //     PERMITIONS.GSTANALISTA,
  //     PERMITIONS.GSTNORMATIVO
  //   ],
  //   title: 'GERAL'
  // },
  {
    page: <Dashboard />,
    path: '/gst/relatorios/dashboard',
    permition: [
      PERMITIONS.ADMINISTRADOR,
      PERMITIONS.GSTANALISTA,
      PERMITIONS.GSTNORMATIVO,
      PERMITIONS.CSNTI
    ],
    title: 'DASHBOARD'
  }
]

export default function Routes() {
  const { user, allDatadescripted, isLogged } = useAuth()

  return (
    <Router>
      <AuthProvider>
        <DrawerProvider>
          <Switch>
            <Route
              exact
              path="/validacao/:contratoId/:token"
              component={ValidateUser}
            />
            <Route
              exact
              path="/recuperar/:token"
              component={PasswordRecovery}
            />
            <Route
              exact
              path="/validacaoAcesso/:token"
              component={AcessEmail}
            />
            <Route exact path="/ngt/access" component={NGTAccess} />
            <Route
              exact
              path="/fornecedor/access"
              component={FornecedoAccess}
            />
            <Route exact path="/" component={FornecedoAccess} />
            {paths?.map((props) => (
              <RouteWithTitle
                key={props?.path}
                permitions={props?.permition}
                isCsn={allDatadescripted?.Perfil === 'Csn'}
                isLogged={isLogged}
                perfilId={user?.PerfilUsuarioId}
                {...props}
              />
            ))}
            <Route path="*" component={NotFound} />
          </Switch>
        </DrawerProvider>
      </AuthProvider>
    </Router>
  )
}
